import {
    getRefererFromRoute,
    getUnlocalizedPathFromRoute,
} from '@marketplace/helpers/router.js'
import { categoryPathMapping } from '@marketplace/helpers/segment.js'
import { pageView } from '@marketplace/helpers/segment/index.js'
import Cookies from 'js-cookie'

/**
 * Track the page view
 *
 * @param {object} context
 */
export default function (context) {
    const locale = context.i18n.locale
    const localeLessPath = getUnlocalizedPathFromRoute(context.route, locale)

    const otherBatchedPayload = {}

    const categoryPath = context.route.params.categoryPath
    const page = context.route.query?.page

    const referrer = getRefererFromRoute(context.route)

    if (categoryPath) {
        Object.assign(otherBatchedPayload, categoryPathMapping(categoryPath))
    }

    if (page) {
        Object.assign(otherBatchedPayload, { currentPage: page })
    }

    Object.assign(otherBatchedPayload, {
        webkitVisibilityState: document.webkitVisibilityState,
        customHeaders: Cookies.get('oc-request-headers') || 'no headers',
    })

    pageView({
        locale,
        localeLessPath,
        fullPath: context.route.fullPath,
        referrer,
        otherBatchedPayload: {
            ...otherBatchedPayload,
        },
    })
}
